import React from 'react';
import { get } from 'lodash';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router';
import { useTimelineEvents } from 'common/hooks';
import { Card, CardHeader } from 'common/Card';
import { AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';
import ServiceAuthorizationTimelineEvent from './ServiceAuthorizationTimelineEvent';
import useAuthorizationWithLineage from '../hooks/useAuthorizationWithLineage';

const filterVoidedTimelineEvents = (timelineEvents, isAuthVoided) => {
  const filteredTimelineEvents = timelineEvents.map((timelineEvent, index) => {
    const eventChanges = get(timelineEvent, 'changes');
    const stateText = eventChanges.find((change) => change.field_name === 'state')?.to;
    if (stateText === AUTHORIZATION_STATUSES.void) {
      if (index === 0 && isAuthVoided) {
        return timelineEvent;
      }
      return null;
    }

    return timelineEvent;
  });

  return filteredTimelineEvents.filter(Boolean);
};

const ServiceAuthorizationTimelineEventsCard = ({ serviceAuthorizationId, isAuthVoided }) => {
  const timelineEvents = useTimelineEvents('service_authorization', serviceAuthorizationId);
  const serviceAuthorizationTimelineEvents = filterVoidedTimelineEvents(timelineEvents, isAuthVoided);
  const { lineageAuthorizations } = useAuthorizationWithLineage({ id: serviceAuthorizationId });
  const relatedAuthorizations = lineageAuthorizations.filter(({ id }) => id !== serviceAuthorizationId).reverse();

  return (
    <Card className="bg-white" data-testid="service-authorization-timeline-history">
      <CardHeader className="pt-2 space-y-2" title="History" />
      <div className="mt-4 max-w-3xl grid grid-cols-12 gap-4">
        <div className="col-span-3 font-heavy-font text-text-blue text-14px">Status Updates:</div>
        <div className="col-span-9 pb-4">
          <ul className="pl-0 list-unstyled">
            {serviceAuthorizationTimelineEvents.map((serviceAuthorizationTimelineEvent) => (
              <ServiceAuthorizationTimelineEvent
                key={`service-authorization-timeline-event-${serviceAuthorizationTimelineEvent.id}`}
                timelineEvent={serviceAuthorizationTimelineEvent}
              />
            ))}
          </ul>
        </div>
        {relatedAuthorizations.length > 0 && (
          <>
            <div className="col-span-3 font-heavy-font text-text-blue text-14px">Related Requests:</div>
            <div className="col-span-9 pb-4 space-y-2">
              {relatedAuthorizations.map((authorization) => (
                <div>
                  <Link
                    className="text-current-blue"
                    key={authorization.id}
                    to={`/authorizations/${authorization.id}`}
                  >
                    {authorization.short_id}
                  </Link>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </Card>
  );
};

ServiceAuthorizationTimelineEventsCard.propTypes = {
  serviceAuthorizationId: PropTypes.string.isRequired,
  isAuthVoided: PropTypes.bool.isRequired,
};

export default ServiceAuthorizationTimelineEventsCard;
